import { BaseModel } from '@abb-procure/data';
import type { SearchFilterValueDto } from '../types/search-filter-value-dto.type';

export class SearchFilterValueModel extends BaseModel {
  readonly id: string | null;
  readonly name: string | null;
  readonly code: string | null;
  readonly color: string | null;
  readonly order: number | null;
  readonly defaultSelected: boolean | null;

  constructor(data: SearchFilterValueDto) {
    super();

    this.id = data.id;
    this.name = data.name;
    this.code = data.code;
    this.color = data.color;
    this.order = data.order;
    this.defaultSelected = data.defaultSelected;
  }

  getDisplay(): string {
    return this.name ?? this.code ?? this.id ?? '';
  }
}
